/**
 * Formats a number to one decimal place, removing trailing zeros.
 * Examples: 1.0 -> "1", 2.6 -> "2.6", 55.9994 -> "56"
 */
export const parseNumericValue = (
  number: number,
  factionDigits = 1,
): string => {
  const roundedNumber = Math.round(number * 10) / 10;
  return roundedNumber % 1 === 0
    ? roundedNumber.toString()
    : roundedNumber.toFixed(factionDigits);
};
